export default __webpack_public_path__ + "static/media/arrow.4a4244e0.png";